import { render, staticRenderFns } from "./UploadQuizQuestion.vue?vue&type=template&id=7f2a1343"
import script from "./UploadQuizQuestion.vue?vue&type=script&lang=js"
export * from "./UploadQuizQuestion.vue?vue&type=script&lang=js"
import style0 from "./UploadQuizQuestion.vue?vue&type=style&index=0&id=7f2a1343&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports